import { create } from 'zustand';

interface AppState {
  capturedImage: string | null;
  extractedText: string;
  isProcessing: boolean;
  isSettingsOpen: boolean;
  isRecording: boolean;
  ocrLanguage: string;
  setImage: (image: string | null) => void;
  setText: (text: string) => void;
  setProcessing: (processing: boolean) => void;
  setSettingsOpen: (open: boolean) => void;
  setRecording: (recording: boolean) => void;
  setOcrLanguage: (language: string) => void;
  reset: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  capturedImage: null,
  extractedText: '',
  isProcessing: false,
  isSettingsOpen: false,
  isRecording: false,
  ocrLanguage: 'eng',
  setImage: (image) => set({ capturedImage: image }),
  setText: (text) => set({ extractedText: text }),
  setProcessing: (processing) => set({ isProcessing: processing }),
  setSettingsOpen: (open) => set({ isSettingsOpen: open }),
  setRecording: (recording) => set({ isRecording: recording }),
  setOcrLanguage: (language) => set({ ocrLanguage: language }),
  reset: () => set({
    capturedImage: null,
    extractedText: '',
    isProcessing: false,
    isRecording: false,
  }),
}));